import { createContext, useState, useEffect } from "react";

const ThemeContext = createContext();

function getWindowDimensions() {
  if(window.innerWidth >= 768){
    return false;
  }
  return true;
}

export function ThemeProvider({children}){

  const [isMobile, setIsMobile] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  
  useEffect(()=>{
    if(window.innerWidth >= 768){
      setIsMobile(false);
    } else {
      setIsMobile(true);
    }
    function checkIsMobile() {
      setIsMobile(getWindowDimensions());
    }

    window.addEventListener('resize', checkIsMobile);
    return () => window.removeEventListener('resize', checkIsMobile);

  },[]);

  return (
    <ThemeContext.Provider value={{isMobile, isLoading, setIsLoading}}>      
      {children}
    </ThemeContext.Provider>
  )
}


export default ThemeContext;